import { Router } from '@angular/router';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  Renderer2,
  inject,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatCheckboxChange, MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {
  MatAutocompleteModule,
  MatAutocompleteSelectedEvent,
} from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { CommonService } from '../../../services/common.service';
import { CommonModule } from '@angular/common';
import { MatStepperModule } from '@angular/material/stepper';
import { MatButtonModule } from '@angular/material/button';
import { HostConnectionService } from '../../../services/host-connection.service';
import { OriginService } from '../../../services/origin.service';
import {
  Company,
  Endorsement,
  Fees,
  LoanData,
  Order,
  Origin,
  PrimaryContact,
  ProductType,
  Status,
  TransactionStatus,
  UnisourceData,
  UnisourceRequestType,
  UploadDocumentsResponse,
  FormStatus,
  UploadDocumentsStatus,
  LogType,
} from '../../../models/loanData.model';
import { AuthService } from '../../../services/auth.service';

declare var $: any;
declare var bootstrap: any;

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatButtonModule,
    MatStepperModule,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css',
})
export class HomeComponent {

  loginForm!: FormGroup;
  LoanDataForm!: FormGroup;
  commonForm!: FormGroup;
  titleOrderForm!: FormGroup;
  titleFeesForm!: FormGroup;
  emailForm!: FormGroup;
  payoffsForm!: FormGroup;
  verificationsForm!: FormGroup;
  schedulerForm!: FormGroup;
  workflowId: string = '';
  formData: any;

  loanPurposeList: { key: string; value: string }[] = [
    { key: 'ConstructionOnly', value: 'Construction Only' },
    { key: 'ConstructPayment', value: 'Construct Payment' },
  ];
  loanTypeList: { key: string; value: string }[] = [
    { key: 'FHA', value: 'FHA' },
    { key: 'Conventional', value: 'Conventional' },
  ];
  titleOrderList: { key: string; value: string }[] = [
    { key: '5165156', value: '5165156' },
    { key: '5165157', value: '5165157' },
    { key: '5165155', value: '5165155' },
  ];

  primaryContactList: PrimaryContact[] = [];
  transactionTypeList: { id: number; name: string }[] = [
    { id: 3, name: 'Purchase' },
    { id: 2, name: 'Refinance' },
    { id: 9, name: 'Assumptions' },
  ];
  defaultTransactionType: any = this.transactionTypeList[1]; //Refinance
  productServiceAllList: ProductType[] = [];
  productServiceList: any[] = [];
  productServiceFeesList: any[] = [];
  teamsList: { key: string; value: string }[] = [
    { key: 'Team1', value: 'Team1' },
    { key: 'Team2', value: 'Team2' },
    { key: 'Team3', value: 'Team3' },
    { key: 'Team4', value: 'Team4' },
    { key: 'Team5', value: 'Team5' },
    { key: 'Team6', value: 'Team6' },
    { key: 'Team-7', value: 'Team-7' },
    { key: 'Team8', value: 'Team8' },
    { key: 'Team9', value: 'Team9' },
    { key: 'Team10', value: 'Team10' },
    { key: 'Team11', value: 'Team11' },
    { key: 'Team12', value: 'Team12' },
  ];
  defaultTeam: string = this.teamsList[0].key;
  payoffInformationList: { key: string; value: string }[] = [
    { key: 'Lender Order Payoff', value: 'Lender Order Payoff' },
    { key: 'Lender Order Subordinate', value: 'Lender Order Subordinate' },
    {
      key: 'Lender Order Both Payoff Subordinate',
      value: 'Lender Order Both Payoff Subordinate',
    },
    { key: 'Title Company Order Payoff', value: 'Title Company Order Payoff' },
    {
      key: 'Title Company Order Subordinate',
      value: 'Title Company Order Subordinate',
    },
    {
      key: 'Title Company Order Both Payoff Subordinate',
      value: 'Title Company Order Both Payoff Subordinate',
    },
  ];
  lienPriorityList: { key: string; value: string }[] = [
    { key: 'First', value: 'First' },
    { key: 'Second', value: 'Second' },
  ];
  liabilityTypeList: { key: string; value: string }[] = [
    { key: 'Mortgage loan', value: 'Mortgage loan' },
    { key: 'HELOC', value: 'HELOC' },
    { key: 'Second Mortgage', value: 'Second Mortgage' },
    {
      key: 'Collections Judgements and Liens',
      value: 'Collections Judgements and Liens',
    },
    { key: 'Other Liability', value: 'Other Liability' },
  ];

  stateList: { key: string; value: string }[] = [];

  feesList: Fees[] = [];
  endorsements: Endorsement[] = [];

  private hostService = inject(HostConnectionService);
  private originService = inject(OriginService);
  private router = inject(Router);

  transactionId: string = '57bc3e78-c608-4556-abe0-2e63496d31b2';
  loanNumber: string = '';
  instanceId: string = '';
  _originData!: Origin | null;
  _loanData!: LoanData;
  _unisourceData!: UnisourceData;
  _credentials!: Company;
  borrowerAddress: string = '';
  employment: any;
  borrower: any;
  payOffQuestionsFlag: boolean = false;
  policyQuetionsFlag: boolean = false;
  _uploadDocuments: any[] = [];
  _documents: any[] = [];
  _orders: Order[] = [];
  orderId: number = 0;
  orderNumber: string = '';
  _payOffsAttachments: any[] = [];
  _verificationAttachments: any[] = [];
  _emailAttachments: any[] = [];

  initializationInformation: any = null;
  orderStatus = 0;
  submitPlaceOrder = false;
  selectedProviders: string = '';
  selectedProducts: string = '';
  borrowerDataArray: any[] = [];

  feedbackMessage = 'Initializing...';
  loadingStatus: 'LOADING' | 'TIMEOUT' | 'ERROR' | 'LOGIN FAILED' | 'LOGIN' =
    'LOADING';

  isOrderInitiating: boolean = false;
  isOrderSubmit: boolean = false;
  isOrderFailed: boolean = false;
  orderProcessingMessage: string = 'Loading...';
  transactionStatus!: Status | null;
  isProcessDoneLoading: boolean = false;
  isProcessViewOrderLoading: boolean = false;
  isProcessViewDocumentUploadLoading: boolean = false;
  isDocumentLoading: boolean = false;
  documentsResponseStatusList: UploadDocumentsResponse[] = [];
  isFormSubmitLoading: boolean = false;
  uploadDocumentsStatus = UploadDocumentsStatus;
  titleFeesFormPayload: any;
  isFeesImportForStatus: boolean = false;
  _transactionStatus = TransactionStatus;

  constructor(
    public commonService: CommonService,
    private renderer: Renderer2,
    private authService: AuthService
  ) {
    this.stateList = this.commonService.stateList;
    this.loadLoginFormControls();
    this.loadLoanFormControls();
    this.loadCommonFormControls();
    this.loadtitleOrderFormControls();
    this.loadtitleFeesFormControls();
    this.loadEmailFormControls();
    this.loadPayoffsFormControls();
    this.loadVerificationsFormControls();
    this.loadSchedulerFormControls();
  }

  async getRoles() {
    var resources = await this.hostService.openRolesForm();
    console.log('getRoles: ', resources);
  }

  async getPersonas() {
    var resources = await this.hostService.openPersonasForm();
    console.log('getPersonas: ', resources);
  }

  async getEligibleServiceSetups() {
    var resources = await this.hostService.openEligibleServiceSetupsForm();
    console.log('getEligibleServiceSetups: ', resources);
  }

  async setContext() {
    var resources = await this.hostService.openSetContextForm();
    console.log('setContext: ', resources);
  }

  async getContext() {
    var resources = await this.hostService.openGetContextForm();
    console.log('getContext: ', resources);
  }

  async ngOnInit() {
    await this.hostService.initializeHost();
    this.getTransactionOriginInformation();
  }
  ngAfterViewInit(): void {
    const modalElement = document.getElementById('loadingProcessDetailModal');
    this.modalInstance = new bootstrap.Modal(modalElement, {
      backdrop: 'static',
      keyboard: false,
    });
    const documentProcessModalElement = document.getElementById(
      'loadingDocumentProcessDetailModal'
    );
    this.documentProcessModalInstance = new bootstrap.Modal(
      documentProcessModalElement,
      { backdrop: 'static', keyboard: false }
    );
    const formSubmitionProcessModalElement = document.getElementById(
      'loadingFormsSubmitProcessDetailModal');
    this.formSubmissionProcessModalInstance = new bootstrap.Modal(
      formSubmitionProcessModalElement,
      { backdrop: 'static', keyboard: false }
    );
    const requiredFieldsModalElement = document.getElementById('requiredFieldsModal');
    this.requiredFieldsModalInstance = new bootstrap.Modal(
      requiredFieldsModalElement,
      { backdrop: 'static', keyboard: false }
    );

    const feesDetailModalElement = document.getElementById('feesDetailModal');
    this.feesDetailModalInstance = new bootstrap.Modal(feesDetailModalElement, { backdrop: 'static', keyboard: false });

    const transactionResponseAPIStatusModalElement = document.getElementById('transactionResponseAPIStatusModal');
    this.transactionResponseAPIStatusModalInstance = new bootstrap.Modal(transactionResponseAPIStatusModalElement, { backdrop: 'static', keyboard: false });
  }
  ngOnDestroy() { }

  async getTransactionOriginInformation() {
    try {
      console.log('Launch application: ', this.feedbackMessage);
      this.feedbackMessage = 'Connecting to Encompass Partner Connect...';
      setTimeout(() => {
        this.feedbackMessage = 'Authenticating...';
      }, 1000);

      this.commonService.startSpinner();
      var origin = await this.hostService.getTransactionOrigin();
      console.log(origin);
      this.transactionId = origin.transactionId || '';
      this._originData = await this.originService.getLoanData(origin.id, origin.partnerAccessToken);
      //this._originData = await this.originService.getLoanData(this.transactionId);
      this.commonService.stopSpinner();
      this.authService.setJWTToken(this._originData?.jwtToken || '');
      if (this.transactionId && this.transactionId.trim() !== '') {
        this.viewOrEditDetail();
      }
      if (this._originData) {
        if (this._originData.loanData) {
          this.instanceId = this._originData.instanceId || '';
          this._loanData = this._originData.loanData;
          this.loanNumber = this._loanData.loanNumber || '';
          console.log('loan data: ', this._loanData);
          this.rebindLoanDataForm(this._loanData);
          this.rebindTitleFeesForm();
          this.rebindTitleOrderForm();
        }
        if (this._originData.unisourceData) {
          this._unisourceData = this._originData.unisourceData;
          this.BindOrderListFromOrigins(this._unisourceData.orders);
          this.payOffQuestionsFlag = this._unisourceData.questionSetting.isPayOffQuestions;
          this.policyQuetionsFlag = this._unisourceData.questionSetting.isPolicyQuestions;
          this.productServiceAllList = this._unisourceData.productTypes;
          this.primaryContactList = this._unisourceData.primaryContacts;
          this.commonForm.patchValue({
            primaryContact: this.primaryContactList[0],
          });
          this.endorsements = this._unisourceData.endorsments;
        }
        if (this._originData.company) {
          this._credentials = this._originData.company;
          this.commonService.setUser(this._credentials);
          this.commonForm.patchValue({
            primaryContact: this._credentials.username,
          });
        }
      } else {
        //this.commonService.openSnackBar('No data found', '', 'warning');
      }
    } catch (error: any) {
      console.log(
        'Error occurred while fetching transaction origin: ',
        error.message
      );
      if (error.message === 'Requesting authentication token timed out.') {
      }
    }

    if (this._loanData?.property?.loanPurposeType?.toLowerCase() === 'purchase') {
      this.defaultTransactionType = this.transactionTypeList[0]; // Purchase
    }
    this.onOrderTransactionTypeChange({
      value: this.defaultTransactionType,
      source: { triggerValue: this.defaultTransactionType.name },
    });
    this.onFeesTransactionTypeChange({
      value: this.defaultTransactionType,
      source: { triggerValue: this.defaultTransactionType.name },
    });
  }

  rebindLoanDataForm(loanData: LoanData) {
    const application = loanData?.applications?.[0];
    this.borrower = application?.borrower;
    this.employment = this.borrower?.employment?.[0];
    if (this.borrower && loanData?.property) {
      const property = loanData.property;
      this.borrowerAddress = `${property.streetAddress ?? ''}, ${property.city ?? ''}, ${property.state ?? ''} ${property.postalCode ?? ''}`.trim();
      this.LoanDataForm.patchValue({
        loanNumber: loanData.loanNumber,
        borrower: `${this.borrower.firstName} ${this.borrower.lastName}`,
        propertyAddress: this.borrowerAddress,
        loanPurpose: loanData.property.loanPurposeType,
        loanType: loanData.mortgageType,
      });
      this.rebindScheduler();
    }
  }

  rebindScheduler() {
    this.schedulerForm.patchValue({
      borrowerAddress: this.borrowerAddress,
      phone: this.borrower.homePhoneNumber ?? '',
      cellPhone: this.borrower.mobilePhone ?? '',
      workPhone: this.employment?.phoneNumber ?? '',
    });
  }

  rebindTitleFeesForm() {
    this.titleFeesForm.patchValue({
      loanAmount: this._loanData.baseLoanAmount,
      salesPrice: this._loanData.purchasePriceAmount,
      streetAddress: this._loanData?.property?.streetAddress ?? '',
      city: this._loanData?.property?.city ?? '',
      state: this._loanData?.property?.state ?? '',
      postalCode: this._loanData?.property?.postalCode ?? '',
      county: this._loanData?.property?.county ?? '',
    });
  }
  rebindTitleOrderForm() {
    this.titleOrderForm.patchValue({
      loanAmount: this._loanData.baseLoanAmount,
      salesPrice: this._loanData.purchasePriceAmount,
    });
  }

  async viewOrEditDetail() {
    this.isOrderInitiating = true;
    const transactionStatus = await this.getOrderAndTitleStatus();
    if (transactionStatus) {
      this.isOrderSubmit = true;
      this.transactionStatus = transactionStatus;
      this.orderProcessingMessage = 'Transaction Failed';
      //this.isOrderFailed = true;
      if (transactionStatus.status.toLowerCase() === TransactionStatus.Completed || transactionStatus.status.toLowerCase() === 'submitted')
        this.orderProcessingMessage = 'Transaction Completed';
      else if (transactionStatus.status.toLowerCase() === TransactionStatus.Pending)
        this.orderProcessingMessage = 'Transaction Pending';
      else if (transactionStatus.status.toLowerCase() === TransactionStatus.Processing)
        this.orderProcessingMessage = 'Transaction Processing';

    }
  }

  refreshPage(): void {
    window.location.reload();
  }

  loadLoginFormControls() {
    this.loginForm = new FormGroup({
      userId: new FormControl('superadmin@awesometechinc.com', [
        Validators.required,
      ]),
      password: new FormControl('321654987', [Validators.required]),
      isSaveLoginInformation: new FormControl(false),
    });
  }

  loadLoanFormControls() {
    this.LoanDataForm = new FormGroup({
      loanNumber: new FormControl({ value: '202504002', disabled: true }, [
        Validators.required,
      ]),
      borrower: new FormControl({ value: 'Abe Lee', disabled: true }, [
        Validators.required,
      ]),
      propertyAddress: new FormControl({ value: 'TBD #B-95 Santa Ana, CA 92705', disabled: false }),
      loanPurpose: new FormControl(
        { value: 'ConstructionOnly', disabled: true },
        [Validators.required]
      ),
      loanType: new FormControl({ value: 'FHA', disabled: true }, [
        Validators.required,
      ]),
    });
  }

  loadCommonFormControls() {
    this.commonForm = new FormGroup({
      titleOrder: new FormControl({ value: '', disabled: true }, [
        Validators.required,
      ]),
      primaryContact: new FormControl('', [Validators.required]),
    });
  }
  loadtitleOrderFormControls() {
    this.titleOrderForm = new FormGroup({
      transactionType: new FormControl(this.defaultTransactionType, [
        Validators.required,
      ]),
      productServices: new FormControl('', [Validators.required]),
      salesPrice: new FormControl('', [Validators.required, Validators.min(1)]),
      loanAmount: new FormControl('', [Validators.required, Validators.min(1)]),
      comments: new FormControl(''),
      consideration: new FormControl(0), // number instead of ''
      policyDate: new FormControl(''),
      amount: new FormControl(0),
    });
  }
  loadtitleFeesFormControls() {
    this.titleFeesForm = new FormGroup({
      transactionType: new FormControl(this.defaultTransactionType, [
        Validators.required,
      ]),
      productServices: new FormControl('', [Validators.required]),
      salesPrice: new FormControl('', [Validators.required, Validators.min(1)]),
      loanAmount: new FormControl('', [Validators.required, Validators.min(1)]),
      consideration: new FormControl(0),
      policyDate: new FormControl(''),
      amount: new FormControl(0),
      streetAddress: new FormControl(''),
      city: new FormControl('', [Validators.required]),
      state: new FormControl('', [Validators.required]),
      postalCode: new FormControl('', [Validators.required]),
      county: new FormControl('', [Validators.required]),
    });
  }
  loadEmailFormControls() {
    this.emailForm = new FormGroup({
      team: new FormControl(this.defaultTeam, [Validators.required]),
      comments: new FormControl('', [Validators.required]),
      isTeamEmail: new FormControl(true),
    });
  }
  loadPayoffsFormControls() {
    this.payoffsForm = new FormGroup({
      borrowerLastFourSocial: new FormControl('', [Validators.pattern(/^\d{4}$/)]),
      lenderName: new FormControl(''),
      liabilityType: new FormControl(''),
      payoffInformation: new FormControl(''),
      lienPriority: new FormControl(''),
      team: new FormControl(this.defaultTeam, [Validators.required]),
      comments: new FormControl(''),
      isPayoffEmail: new FormControl(true),
    });
  }
  loadVerificationsFormControls() {
    this.verificationsForm = new FormGroup({
      isInsuranceVerification: new FormControl(false),
      companyName: new FormControl(''),
      companyPhone: new FormControl(''),
      companyAccountNumber: new FormControl(''),
      isAsssociateVerification: new FormControl(false),
      associateName: new FormControl(''),
      associatePhone: new FormControl(''),
      associateAccountNumber: new FormControl(''),
      team: new FormControl(this.defaultTeam, [Validators.required]),
      comments: new FormControl(''),
      isVerificationEmail: new FormControl(true),
    });
  }
  loadSchedulerFormControls() {
    this.schedulerForm = new FormGroup({
      borrowerAddress: new FormControl({ value: '', disabled: true }),
      requestedDateTime: new FormControl(this.formatDateTime(new Date())),
      team: new FormControl(this.defaultTeam, [Validators.required]),
      phone: new FormControl(''),
      cellPhone: new FormControl(''),
      workPhone: new FormControl(''),
      isBorrowerAddress: new FormControl(false),
      location: new FormControl(''),
      comments: new FormControl(''),
      isScheduleEmail: new FormControl(true),
    });
  }

  isPrintToeFolder: boolean = false;
  onPrintToeFolderChange(event: any) {
    this.isPrintToeFolder = event.target.checked;
    this.loginForm.patchValue({ isPrintToeFolder: this.isPrintToeFolder });
    if (this.isPrintToeFolder) {
    }
  }
  onSaveLoginInformationCheckboxChange(event: any) {
    const isChecked = event?.checked;
    this.loginForm.patchValue({ isPrintToeFolder: isChecked });
    if (isChecked) {
    }
  }

  formatDateTime(date: Date): string {
    const pad = (num: number) => num.toString().padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
      date.getDate()
    )}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
  }

  getErrorMessage(dataObject: any): string {
    return this.commonService.getErrorMessage(dataObject);
  }

  onReset(): void {
    this.commonService.onReset(this.loginForm);
  }

  onLoginFormSubmit() {
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
    } else {
      //this.update.emit(this.loginForm.value); // Emit updated form data to parent
    }
  }

  onLoanFormSubmit() {
    if (this.LoanDataForm.invalid) {
      this.LoanDataForm.markAllAsTouched();
    } else {
      //this.update.emit(this.LoanDataForm.value); // Emit updated form data to parent
    }
  }

  searchText: string = '';
  applyFilter() {
    const search = this.searchText.toLowerCase().trim();
    if (!search) {
      this.filterdTransactionHistoryList = [...this.transactionHistoryList];
      return;
    }
    this.filterdTransactionHistoryList = this.transactionHistoryList.filter(item => {
      return (
        item.orderNumber?.toString().toLowerCase().includes(search) ||
        item.loanNumber?.toString().toLowerCase().includes(search) ||
        item.loanAmount?.toString().includes(search) ||
        item.salesPrice?.toString().includes(search) ||
        item.productType?.toLowerCase().includes(search) ||
        item.transactionType?.toLowerCase().includes(search) ||
        item.reswareUserName?.toLowerCase().includes(search) ||
        item.createdAt?.toLowerCase().includes(search)
      );
    });
  }

  isViewOrderHistory: boolean = false;
  transactionHistoryList: any[] = [];
  filterdTransactionHistoryList: any[] = [];
  async getOrderHistory() {
    this.isViewOrderHistory = true;
    this.transactionHistoryList = [];
    this.transactionHistoryList = (await this.originService.getOrderHistory(this.loanNumber, this.instanceId)) || [];
    this.applyFilter();
    this.showOrderFeesStatusHistoryModal();
  }
  async getFeesHistory() {
    this.isViewOrderHistory = false;
    this.transactionHistoryList = [];
    this.transactionHistoryList = (await this.originService.getFeesHistory(this.loanNumber, this.instanceId)) || [];
    this.applyFilter();
    this.showOrderFeesStatusHistoryModal();
  }

  reInitializeTransactionProcess() {
    this.isOrderInitiating = false;
    this.isOrderSubmit = false;
    this.isOrderFailed = false;
    this.orderProcessingMessage = 'Initiating...';
    this.transactionStatus = null;
  }
  onProcessDoneButtonClick() {
    this.isProcessDoneLoading = true;
    this.isEPCNotRespondingLoading = true;
    setTimeout(() => {
      this.isProcessDoneLoading = false;
      this.isEPCNotRespondingLoading = false;
      this.reInitializeTransactionProcess();
      this.hostService.close();
    }, 1000);
  }

  onProcessViewDetailOrderButtonClick() {
    this.isProcessViewOrderLoading = true;
    setTimeout(() => {
      this.isProcessViewOrderLoading = false;
      this.reInitializeTransactionProcess();
    }, 1000);
  }
  onLoadingProcessDialogDoneButtonClick() {
    this.isProcessDoneLoading = true;
    setTimeout(() => {
      this.hideLoadingProcessDetailModal();
      this.processingStatusDetail = { ...this.defaultProcessingStatusDetail };
      this.isProcessDoneLoading = false;
      this.transactionStatus = null;
    }, 1000);
  }

  onProcessViewDetailDocumentUploadButtonClick() {
    this.isProcessViewDocumentUploadLoading = true;
    setTimeout(() => {
      this.reInitializeTransactionProcess();
      this.isProcessViewDocumentUploadLoading = false;
    }, 1000);
    setTimeout(() => {
      ($('#pills-report-test-tab') as any).tab('show');
      this.onTabChange('uploadDocuments');
    }, 1100);
  }

  confirmationOrder() {
    if (this.checkRequiredFields()) {
      return;
    }
    if (this.titleOrderForm.invalid) {
      this.titleOrderForm.markAllAsTouched();
      return;
    }
    if (this.transactionId && this.transactionId.trim() !== '') {
      this.commonService.confirm('Confirmation', 'Create a new order anyway?').subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.onTitleOrderFormSubmit();
        } else {
          //console.log('User canceled deletion');
        }
      });
    } else {
      this.onTitleOrderFormSubmit();
    }
  }
  async onTitleOrderFormSubmit() {

    // Destructure the properties you want to exclude and collect the rest
    let { amount, policyDate, consideration, ...filteredOrderForm } =
      this.titleOrderForm.value;
    const { titleOrder, ...filteredCommonForm } =
      this.commonForm.getRawValue();

    // Construct the question object with the excluded properties
    let priorPolicy = {};
    if (this.payOffQuestionsFlag && amount > 0 && consideration > 0) {
      priorPolicy = { amount, policyDate, consideration };
    }
    if (this.policyQuetionsFlag && consideration > 0) {
      priorPolicy = { ...priorPolicy, policyDate, consideration };
    }

    // Combine the filtered order form with the common form values
    const payload = {
      ...filteredOrderForm,
      ...filteredCommonForm,
      //...(Object.keys(priorPolicy).length > 0 ? { priorPolicy } : {}),
      isNewOrder: true,
    };
    let requestType = UnisourceRequestType.Order;
    // For Heloc: 29
    if (payload?.productServices?.id === 29) {
      requestType = UnisourceRequestType.OrderUninsured;
    }
    // Build the transaction request
    const transactionRequest = {
      request: {
        type: requestType,
        options: payload,
        resources: [],
      },
    };

    this.processingStatusDetail.IsFeesImport = false;
    this.showLoadingProcessDetailModal();
    console.log('Transaction Request:', transactionRequest);
    try {
      this.disableCloseButton();
      this.setTimeoutForEPCNotResponding();
      const result = await this.hostService.createTransaction(transactionRequest);
      console.log('Order Transaction Response:', result);

      if (result) {
        this.transactionId = result?.id || '';
        this.hostService.setTransactionId(this.transactionId);
        this.clearEPCNotRespondingTimeout();
        this.startIntervalForGetTransactionStatus(this.transactionId);
      }
    } catch (error: any) {
      this.clearEPCNotRespondingTimeout();
      this.enableCloseButton();
      console.log('Error occurred while creating order transaction: ', { error });
      this.commonService.openSnackBar('Error occurred while transaction', '', 'error');
    }
    //this.startIntervalForGetTransactionStatus(this.transactionId);

  }

  intervalId: any;
  intervalTimeoutId: any;
  async startIntervalForGetTransactionStatus(transactionId: string) {
    this.isProcessStop = false;

    if (this.intervalId) clearInterval(this.intervalId);
    if (this.intervalTimeoutId) clearTimeout(this.intervalTimeoutId);

    this.intervalId = setInterval(async () => {
      await this.getTransactionsStatus(transactionId);
    }, 3000);

    // Set 2-minute timeout to stop polling if still incomplete
    this.intervalTimeoutId = setTimeout(() => {
      this.processingStatusDetail.Failed = true;
      this.processingStatusDetail.Message = 'Stopped order status polling after 2 minutes without completion';
      this.onProcessStop();
      console.warn('Stopped order status polling after 2 minutes without completion.');
      this.commonService.openSnackBar('Stopped order status polling after 2 minutes without completion.', '', 'error');
    }, 2 * 60 * 1000); // 2 minutes in milliseconds


  }
  defaultProcessingStatusDetail = {
    Processing: false,
    OrderSubmited: false,
    UpdatingLoan: false,
    Completed: false,
    Failed: false,
    Canceled: false,
    FeesImported: false,
    IsFeesImport: false,
    Message: '',
  };
  processingStatusDetail = { ...this.defaultProcessingStatusDetail };
  isProcessStatusSkip: boolean = false;
  async getTransactionsStatus(transactionId: string): Promise<void> {

    this.transactionStatus = await this.originService.getOrderStatus(transactionId);

    if (this.transactionStatus) {
      const { status } = this.transactionStatus;

      let newStatus: any;
      switch (status.toLowerCase()) {
        case TransactionStatus.Completed.toLowerCase():
          newStatus = TransactionStatus.Completed.replace(
            'Completed',
            'Completed Successfully'
          );
          this.processingStatusDetail.Completed = true;
          this.isProcessStatusSkip = true;
          this.getOrders();
          this.onProcessStop();
          break;
        case TransactionStatus.Submited.toLowerCase():
          newStatus = TransactionStatus.Submited;
          this.processingStatusDetail.OrderSubmited = true;
          break;
        case TransactionStatus.FeesImported.toLowerCase():
          newStatus = TransactionStatus.FeesImported;
          this.processingStatusDetail.Completed = true;
          break;
        case TransactionStatus.Pending.toLowerCase():
          newStatus = `${TransactionStatus.Pending}...`;
          break;
        case TransactionStatus.UpdatingLoan.toLowerCase():
          newStatus = `${TransactionStatus.UpdatingLoan}...`;
          this.processingStatusDetail.UpdatingLoan = true;
          break;
        case TransactionStatus.Failed.toLowerCase():
          newStatus = TransactionStatus.Failed;
          this.processingStatusDetail.Failed = true;
          this.processingStatusDetail.Message = `Error: ${this.transactionStatus.message}`;
          this.isProcessStatusSkip = true;
          this.onProcessStop();
          break;
        case TransactionStatus.Cancelled.toLowerCase():
          newStatus = TransactionStatus.Cancelled;
          this.processingStatusDetail.Canceled = true;
          this.processingStatusDetail.Message = `Error: ${this.transactionStatus.message}`;
          this.isProcessStatusSkip = true;
          this.onProcessStop();
          break;
        default:
          newStatus = `${TransactionStatus.Processing}...`;
          this.processingStatusDetail.Processing = true;
      }
      this.orderProcessingMessage = newStatus;
    } else {
      this.onProcessStop();
    }
  }
  isProcessStop: boolean = false;
  private onProcessStop() {
    this.enableCloseButton();
    this.isProcessStop = true;
    clearInterval(this.intervalId);
    clearTimeout(this.intervalTimeoutId);
    this.intervalId = null;
    this.intervalTimeoutId = null;
  }

  orderAndTitleStatusList: Status[] = [];
  async getOrderAndTitleStatus() {
    const orderAndTitleStatusList =
      await this.originService.getTransactionStatus(this.transactionId);
    if (orderAndTitleStatusList) {
      this.orderAndTitleStatusList.push(orderAndTitleStatusList);
    }
    return orderAndTitleStatusList;
  }

  isLoadingObtainedFees: boolean = false;
  async onFeesFormSubmit() {
    if (this.checkRequiredFields(false)) {
      return;
    }

    if (this.titleFeesForm.invalid) {
      this.titleFeesForm.markAllAsTouched();
    } else {
      const endorsements = this.endorsements
        .filter((e) => e.isSelected)
        .map(({ isSelected, ...rest }) => rest);

      // Destructure the properties you want to exclude and collect the rest
      const {
        amount,
        policyDate,
        consideration,
        priorPolicyDate,
        priorPolicyCoverageAmount,
        ...filteredForm
      } = this.titleFeesForm.value;

      // Construct the question object with the excluded properties
      let priorPolicy = {};
      if (this.payOffQuestionsFlag && amount > 0 && consideration > 0) {
        priorPolicy = { amount, policyDate, consideration };
      }
      if (this.policyQuetionsFlag && consideration > 0) {
        priorPolicy = { ...priorPolicy, policyDate, consideration };
      }

      // Combine the filtered order form with the common form values
      this.titleFeesFormPayload = {
        ...filteredForm,
        ...this.commonForm.getRawValue(),
        endorsements,
        ...(Object.keys(priorPolicy).length > 0 ? { priorPolicy } : {}),
      };

      // Build the transaction request
      const transactionRequest = {
        request: {
          type: UnisourceRequestType.Fees,
          options: this.titleFeesFormPayload,
          resources: [],
        },
      };
      this.isLoadingObtainedFees = true;
      console.log('Fees Transaction Request:', transactionRequest);
      try {
        this.setTimeoutForEPCNotResponding();
        const result = await this.hostService.createTransaction(
          transactionRequest
        );
        console.log('Fees Transaction Response:', result);
        if (result) {
          this.transactionId = result?.id || '';
          this.hostService.setTransactionId(this.transactionId);
          this.clearEPCNotRespondingTimeout();
          this.onObtainFeesClick(this.transactionId);
          //this.commonService.openSnackBar("Fees submitted successfully", "", "success");
        }
      } catch (error: any) {
        this.clearEPCNotRespondingTimeout();
        console.log('Error occurred while creating fees transaction: ', {
          error,
        });
        this.commonService.openSnackBar(
          'Error occurred while creating fees transaction',
          '',
          'error'
        );
      }
      //this.onObtainFeesClick(this.transactionId);
      this.isLoadingObtainedFees = false;
    }
  }
  async onObtainFeesClick(transactionId: string) {
    this.feesList = [];
    this.showFeesDetailModal();
    this.feesList = await this.originService.getFees(transactionId);
    if (this.feesList.length > 0) {
      this.feesList = this.feesList.map((fees) => ({
        ...fees,
        isSelected: true,
      }));
      console.log('Fees List: ', this.feesList);
    }
  }
  get totalFeesAmount(): string {
    const total = this.feesList?.reduce((acc, item) => acc + item.amount, 0) || 0;
    return total.toFixed(2); // returns string like "4087.60"
  }

  confirmationImportFeesDialogCancel() {

    this.commonService
      .confirm('Confirmation', 'Are you sure you want to cancel this transaction?')
      .subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.cancelImportFeesTransaction();
        }
      });
  }
  async cancelImportFeesTransaction() {
    console.log('Import Fees Update Canceled Transaction Request');
    const result = await this.originService.cancelFeesTransaction(this.transactionId);
    this.hideFeesDetailModal();
    if (result) {

    }
    else {
      //this.commonService.openSnackBar('Error occurred while updating import fees canceled transaction', '', 'error');
    }
  }

  confirmationFees() {
    const selectedFees = this.feesList.filter((e) => e?.isSelected) || [];
    if (selectedFees.length === 0) {
      this.commonService.openSnackBar('Please select the fees', '', 'warning');
      return;
    }
    this.commonService
      .confirm('Confirmation', 'Are you sure you want to import these fees "')
      .subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.importFees();
        } else {
          //console.log('User canceled deletion');
        }
      });
  }
  async importFees() {

    this.isProcessStop = false;
    this.isFeesImportForStatus = true;

    const selectedFees = this.feesList.filter((e) => e?.isSelected) || [];
    const importFeesToSubmit = selectedFees.map(({ isSelected, ...rest }) => ({
      ...rest,
      amount: `$${Number(rest.amount).toFixed(2)}`, // Ensures it's a number, then formats as string with $
      aprAffectingFee: String(rest.aprAffectingFee), // Converts boolean to 'true'/'false'
    }));

    console.log('Selected Fees List: ', importFeesToSubmit);
    const payload = importFeesToSubmit;
    const response = await this.originService.importFees(payload, this.transactionId);
    if (response) {
      this.startPollingFormStatus('');
    }
    else {
      this.isFeesImportForStatus = false;
    }
  }

  async openEFolderForm(): Promise<any[]> {
    let resourcesList = await this.hostService.openEFolderForm();
    console.log('Resources List: ', resourcesList);
    return resourcesList;
  }
  async selectDocuments() {
    let epcDocsList = await this.openEFolderForm();
    epcDocsList = epcDocsList.map((doc) => ({
      ...doc,
      isSelected: true,
      status: this.uploadDocumentsStatus.Pending,
    }));
    //this._uploadDocuments.push(...epcDocsList);
    this._uploadDocuments.unshift(...epcDocsList);

  }

  async uploadDocuments() {
    if (this.commonForm.invalid) {
      this.commonForm.markAllAsTouched();
      return;
    }

    this.isDocumentLoading = true;
    this.documentsResponseStatusList = this._uploadDocuments.filter((doc) => doc.isSelected)
      .map((doc) => ({
        orderId: 0,
        orderNumber: '',
        transactionId: '',
        documentId: doc.id,
        documentName: doc.name,
        documentStatus: '',
        message: '',
        type: '',
      }));

    const selectedResources =
      this._uploadDocuments.filter((e) => e?.isSelected) || [];
    const uploadDocumentsToSubmit = selectedResources.map(
      ({ isSelected, isDisabled, status, uploadDate, uploadedBy, ...rest }) =>
        rest
    );

    if (uploadDocumentsToSubmit.length === 0) {
      this.commonService.openSnackBar('Please select the documents', '', 'warning');
      this.isDocumentLoading = false;
      return;
    }

    let transactionRequest = {
      request: {
        type: UnisourceRequestType.Order,
        displayFields: [{ label: 'Order Action', value: 'Title Document' }],
        options: { isUploadToResware: true, orderId: this.orderId, orderNumber: this.orderNumber },
        resources: uploadDocumentsToSubmit,
      },
    };
    if (!this.transactionId || this.transactionId.trim() === '') {
      console.log('Resources Transaction Request:', transactionRequest);
      try {
        this.setTimeoutForEPCNotResponding();
        const result = await this.hostService.createTransaction(
          transactionRequest
        );
        if (result) {
          this.transactionId = result?.id || '';
          this.hostService.setTransactionId(this.transactionId);
          this.clearEPCNotRespondingTimeout();
        }
      } catch (error: any) {
        this.clearEPCNotRespondingTimeout();
        console.log('Error occurred while creating resources transaction: ', {
          error,
        });
        this.commonService.openSnackBar(
          'Error occurred while creating resources transaction',
          '',
          'error'
        );
        this.isDocumentLoading = false;
        return;
      }
    } else {
      console.log('Resources Update Transaction Request:', transactionRequest);
      try {
        this.setTimeoutForEPCNotResponding();
        const result = await this.hostService.updateTransaction(
          transactionRequest,
          this.transactionId
        );
        if (result) {
          this.transactionId = result?.id || '';
          this.clearEPCNotRespondingTimeout();
        }
      } catch (error: any) {
        this.clearEPCNotRespondingTimeout();
        console.log('Error occurred while updating resources transaction: ', {
          error,
        });
        this.commonService.openSnackBar(
          'Error occurred while updating resources transaction',
          '',
          'error'
        );
        this.isDocumentLoading = false;
        return;
      }
    }
    // const payload = {
    //   transactionId: this.transactionId,
    //   orderId: this.orderId,
    //   orderNumber: this.orderNumber,
    //   resources: uploadDocumentsToSubmit,
    // };
    // const response = await this.originService.uploadToResware(payload);
    // if (response.length > 0) {
    //   this.documentsResponseStatusList = response;
    // } else {
    // }

    if (uploadDocumentsToSubmit.length > 0) {
      this.showLoadingDocumentProcessDetailModal();
      const documentIds = uploadDocumentsToSubmit.map((doc) => doc.id);
      this.startPollingDocumentsStatus(documentIds, true);
    }
    //this.getOrders(undefined, true);
  }

  startPollingDocumentsStatus(documentIds: any[], isUploadDocuments: boolean) {
    if (this.formsPollingIntervalId) clearInterval(this.formsPollingIntervalId);
    if (this.formsPollingTimeoutId) clearTimeout(this.formsPollingTimeoutId);

    // Start 2-second interval polling
    this.formsPollingIntervalId = setInterval(async () => {
      await this.getDocumentsStatus(documentIds, isUploadDocuments);
    }, 2000);

    // Set 2-minute timeout to stop polling if still incomplete
    this.formsPollingTimeoutId = setTimeout(() => {
      clearInterval(this.formsPollingIntervalId);
      this.formsPollingIntervalId = null;
      this.isDocumentLoading = false;
      console.warn('Stopped polling after 2 minutes without completion.');
      this.commonService.openSnackBar('Stopped polling after 2 minutes without completion.', '', 'error');
      // Optional: show message or update UI here
    }, 2 * 60 * 1000); // 2 minutes in milliseconds
  }

  async getDocumentsStatus(documentIds: any[], isUploadDocuments: boolean) {

    const documentStatusResponse = await this.originService.getDocumentsStatus(documentIds, this.transactionId, isUploadDocuments);
    if (documentStatusResponse.length === 0)
      return;

    //this.documentsResponseStatusList = documentStatusResponse;
    this.documentsResponseStatusList = this.documentsResponseStatusList.map(doc => {
      const updatedDoc = documentStatusResponse.find(d => d.documentId === doc.documentId);
      return updatedDoc ? updatedDoc : doc;
    });

    const allCompletedOrFailed = this.documentsResponseStatusList.every(
      (doc) =>
        doc.documentStatus.toLowerCase() === 'completed' ||
        doc.documentStatus.toLowerCase() === 'failed'
    );
    if (allCompletedOrFailed) {
      clearInterval(this.formsPollingIntervalId);
      clearTimeout(this.formsPollingTimeoutId);
      this.formsPollingIntervalId = null;
      this.formsPollingTimeoutId = null;
      this.isDocumentLoading = false;
    }
  }

  // Toggle Select/Deselect all
  toggleSelectAllUploadDocuments(event: MatCheckboxChange): void {
    const shouldSelect = event.checked;
    this._uploadDocuments.forEach(doc => {
      if (!doc.isDisabled) {
        doc.isSelected = shouldSelect;
      }
    });
  }

  // Return true if all non-disabled documents are selected
  isAllSelectedUploadDocuments(): boolean {
    return this._uploadDocuments
      .filter(doc => !doc.isDisabled)
      .every(doc => doc.isSelected);
  }

  // Return true if *some* non-disabled documents are selected but not all
  isIndeterminateUploadDocuments(): boolean {
    const selectableDocs = this._uploadDocuments.filter(doc => !doc.isDisabled);
    const selectedCount = selectableDocs.filter(doc => doc.isSelected).length;
    return selectedCount > 0 && selectedCount < selectableDocs.length;
  }

  // Toggle Select/Deselect all
  toggleSelectAllDownloadDocuments(event: MatCheckboxChange): void {
    const shouldSelect = event.checked;
    this._documents.forEach(doc => {
      if (!doc.isDisabled) {
        doc.isSelected = shouldSelect;
      }
    });
  }

  // Return true if all non-disabled documents are selected
  isAllSelectedDownloadDocuments(): boolean {
    return this._documents
      .filter(doc => !doc.isDisabled)
      .every(doc => doc.isSelected);
  }

  // Return true if *some* non-disabled documents are selected but not all
  isIndeterminateDownloadDocuments(): boolean {
    const selectableDocs = this._documents.filter(doc => !doc.isDisabled);
    const selectedCount = selectableDocs.filter(doc => doc.isSelected).length;
    return selectedCount > 0 && selectedCount < selectableDocs.length;
  }

  isRetriveDocumentsLoading: boolean = false;
  isRetrieveDocumentsBtnDisplay: boolean = false;
  async getDocuments(orderId: number, orderNumber: string) {
    if (this.activeTab !== 'downloadDocuments') return;

    this.isRetrieveDocumentsBtnDisplay = false;

    if (!this.transactionId || this.transactionId.trim() === '' || orderId === 0) {
      this.isRetrieveDocumentsBtnDisplay = true;
      return;
    }

    this._documents = await this.originService.getDocuments(
      this.transactionId,
      orderId,
      orderNumber
    );
    this._documents = this._documents.map((doc) => ({
      ...doc,
      isSelected: doc.status !== 'Completed', // Select only if not Completed
      isDisabled: doc.status === 'Completed', // Add a flag to disable checkbox
    }));
  }

  async getEPCDocuments(orderId: number, orderNumber: string) {
    if (this.activeTab !== 'uploadDocuments') return;

    if (!this.transactionId || this.transactionId.trim() === '' || orderId === 0) {
      return;
    }

    this._uploadDocuments = await this.originService.getEPCDocuments(
      this.transactionId,
      orderId,
      orderNumber
    );
    this._uploadDocuments = this._uploadDocuments.map((doc) => ({
      ...doc,
      isSelected: doc.status.toLowerCase() !== 'completed', // Select only if not Completed
      isDisabled: doc.status.toLowerCase() === 'completed', // Add a flag to disable checkbox
    }));
  }

  async uploadDocumentsToEfolder() {
    if (this.commonForm.invalid) {
      this.commonForm.markAllAsTouched();
      return;
    }
    this.isDocumentLoading = true;
    this.documentsResponseStatusList = this._documents
      .filter((doc) => doc.isSelected)
      .map((doc) => ({
        orderId: 0,
        orderNumber: '',
        transactionId: '',
        documentId: doc.id,
        documentName: doc.name,
        documentStatus: '',
        message: '',
        type: '',
      }));

    const selectedDocuments = this._documents.filter((e) => e?.isSelected) || [];
    const prepareDocuments = selectedDocuments.map(
      ({ isSelected, isDisabled, ...rest }) => rest
    );
    if (prepareDocuments.length === 0) {
      this.commonService.openSnackBar('Please select the documents', '', 'warning');
      this.isDocumentLoading = false;
      return;
    }
    this.showLoadingDocumentProcessDetailModal();
    const primaryContactEmail = this.commonForm.value?.primaryContact || '';
    const primaryContact = this.primaryContactList.find((x) => x.email === primaryContactEmail);
    const payload = {
      orderId: this.orderId,
      orderNumber: this.orderNumber,
      transactionId: this.transactionId,
      //primaryContactName: `${primaryContact?.firstName} ${primaryContact?.lastName}`,
      //primaryContactEmail: primaryContact?.email || '',
      documents: prepareDocuments,
    };
    const response = await this.originService.uploadDocuments(payload);
    //this.documentsResponseStatusList = response;
    const documentIds = prepareDocuments.map((doc) => doc.id);
    this.startPollingDocumentsStatus(documentIds, false);

    //await this.getDocuments(this.orderId, this.orderNumber);   
  }

  onLoadingDocumentsProcessDialogDoneButtonClick() {
    this.isProcessDoneLoading = true;
    this.retrieveDocuments();
    setTimeout(() => {
      this.hideLoadingDocumentProcessDetailModal();
      this.documentsResponseStatusList = [];
      this.isProcessDoneLoading = false;
    }, 1000);
  }

  async BindOrderListFromOrigins(orders: any[]) {
    this._orders = orders;
    if (this._orders.length > 0) {
      this._orders.sort((a, b) => b.orderId - a.orderId);
      const defaultOrderId = this._orders[0].orderId;
      this.commonForm.patchValue({ titleOrder: defaultOrderId });
      this.onOrdersChange({ value: defaultOrderId, source: { triggerValue: '' } });
    }
  }

  async getOrders(clearDocuments: boolean = true, isExistOrder: boolean = false) {
    this._orders = await this.originService.getOrders(this.loanNumber, this.transactionId);
    if (this._orders.length > 0) {
      this._orders.sort((a, b) => b.orderId - a.orderId);
      await this.setTopRecentOrder(clearDocuments, isExistOrder);
    }
  }

  async setTopRecentOrder(clearDocuments: boolean = true, isExistOrder: boolean = false) {
    let orderId;
    const defaultOrder = this._orders[0];
    if (isExistOrder)
      orderId = this.orderId;
    else
      orderId = defaultOrder.orderId;
    this.commonForm.patchValue({ titleOrder: orderId });
    this.onOrdersChange(
      { value: orderId, source: { triggerValue: '' } },
      clearDocuments
    );
  }

  isOrderCancelledOrClosed: boolean = false;
  onOrdersChange(event: any, clearDocuments: boolean = true): void {
    const selectedKey = event.value;
    //const selectedText = event.source.triggerValue;
    const orderObj = this._orders.find((x) => x.orderId === selectedKey);
    this.orderId = selectedKey || 0;
    this.orderNumber = orderObj?.orderNumber || '';
    this.transactionId = orderObj?.transactionId || '';
    //this.isOrderCancelledOrClosed = orderObj?.status?.toLowerCase() === 'cancelled' || orderObj?.status?.toLowerCase() === 'closed';

    if (clearDocuments) this._documents = [];
    this.getDocuments(this.orderId, this.orderNumber);
    this.getEPCDocuments(this.orderId, this.orderNumber);
  }

  async retrieveDocuments() {
    this.isRetriveDocumentsLoading = true;
    if (!this.transactionId || this.transactionId.trim() === '') {
      this.isRetrieveDocumentsBtnDisplay = true;
      const transactionRequest = {
        request: {
          type: UnisourceRequestType.Order,
          displayFields: [{ label: 'Order Action', value: 'Title Document' }],
          options: {},
          resources: [],
        },
      };
      console.log('Get Documents Transaction Request:', transactionRequest);
      try {
        this.setTimeoutForEPCNotResponding();
        const result = await this.hostService.createTransaction(
          transactionRequest
        );
        if (result) {
          this.transactionId = result?.id || '';
          this.hostService.setTransactionId(this.transactionId);
          this.clearEPCNotRespondingTimeout();
        }
      } catch (error: any) {
        this.clearEPCNotRespondingTimeout();
        console.log(
          'Error occurred while creating get documents transaction: ',
          {
            error,
          }
        );
        this.commonService.openSnackBar(
          'Error occurred while creating get documents transaction',
          '',
          'error'
        );
      }
    }
    await this.getDocuments(this.orderId, this.orderNumber);
    this.getOrders(false, true);
    this.isRetriveDocumentsLoading = false;
  }

  async browsePayOffsDocuments() {
    this._payOffsAttachments = await this.openEFolderForm();
    this._payOffsAttachments = this._payOffsAttachments.map((doc) => ({
      ...doc,
      isSelected: true,
    }));
  }
  async onPayOffsFormSubmit() {
    if (this.commonForm.invalid) {
      this.commonForm.markAllAsTouched();
      return;
    }
    if (this.payoffsForm.invalid) {
      this.payoffsForm.markAllAsTouched();
      return;
    }
    this.isFormSubmitLoading = true;
    const selectedResources =
      this._payOffsAttachments.filter((e) => e?.isSelected) || [];
    const submissionResourcesList = selectedResources.map(
      ({ isSelected, ...rest }) => rest
    );
    const transactionRequest = {
      request: {
        type: UnisourceRequestType.Order,
        options: {
          orderId: this.orderId,
          orderNumber: this.orderNumber,
          ...this.commonForm.getRawValue(),
          ...this.payoffsForm.value,
        },
        resources: submissionResourcesList,
      },
    };
    if (!this.transactionId || this.transactionId.trim() === '') {
      console.log('PayOffs Create Transaction Request:', transactionRequest);
      try {
        this.setTimeoutForEPCNotResponding();
        const result = await this.hostService.createTransaction(
          transactionRequest
        );
        if (result) {
          this.transactionId = result?.id || '';
          this.hostService.setTransactionId(this.transactionId);
          this.clearEPCNotRespondingTimeout();
          this.getOrders(undefined, true);
        }
      } catch (error: any) {
        this.clearEPCNotRespondingTimeout();
        console.log('Error occurred while creating payoffs transaction: ', {
          error,
        });
        this.commonService.openSnackBar(
          'Error occurred while creating payoffs transaction',
          '',
          'error'
        );
        this.isFormSubmitLoading = false;
        return;
      }
    } else {
      console.log('PayOffs Update Transaction Request:', transactionRequest);
      try {
        this.setTimeoutForEPCNotResponding();
        const result = await this.hostService.updateTransaction(
          transactionRequest,
          this.transactionId
        );
        if (result) {
          this.transactionId = result?.id || '';
          this.hostService.setTransactionId(this.transactionId);
          this.clearEPCNotRespondingTimeout();
        }
      } catch (error: any) {
        this.clearEPCNotRespondingTimeout();
        console.log('Error occurred while updating payoffs transaction: ', {
          error,
        });
        this.commonService.openSnackBar(
          'Error occurred while updating payoffs transaction',
          '',
          'error'
        );
        this.isFormSubmitLoading = false;
        return;
      }
    }
    this.startPollingFormStatus('payoff');
    this.isFormSubmitLoading = false;
  }

  onLoadingFormSubmissionProcessDialogDoneButtonClick() {
    this.isProcessDoneLoading = true;
    setTimeout(() => {
      this.hideLoadingFormSubmitionProcessDetailModal();
      this.formStatus = null;

      if (this.isFeesImportForStatus)
        this.hideFeesDetailModal();

      this.isProcessDoneLoading = false;
      this.isFeesImportForStatus = false;
      this._payOffsAttachments = [];
      this._verificationAttachments = [];
      this._emailAttachments = [];
      this.loadPayoffsFormControls();
      this.loadVerificationsFormControls();
      this.loadSchedulerFormControls();
      this.loadEmailFormControls();
      this.rebindScheduler();
    }, 1000);
  }

  formsPollingIntervalId: any;
  formsPollingTimeoutId: any;
  startPollingFormStatus(endPoint: string) {
    if (this.formsPollingIntervalId) clearInterval(this.formsPollingIntervalId);
    if (this.formsPollingTimeoutId) clearTimeout(this.formsPollingTimeoutId);

    this.showLoadingFormSubmitionProcessDetailModal();
    this.formsPollingIntervalId = setInterval(async () => {
      await this.getFormStatus(endPoint);
    }, 2000);

    // Set 2-minute timeout to stop polling if still incomplete
    this.formsPollingTimeoutId = setTimeout(() => {
      clearInterval(this.formsPollingIntervalId);
      this.formsPollingIntervalId = null;
      console.warn('Stopped polling after 2 minutes without completion.');
      this.commonService.openSnackBar('Stopped polling after 2 minutes without completion.', '', 'error');
    }, 2 * 60 * 1000); // 2 minutes in milliseconds

  }

  formStatus!: FormStatus | null;
  async getFormStatus(endPoint: string) {
    if (this.isFeesImportForStatus) {
      this.formStatus = await this.originService.getFeesTransactionsStatus(this.hostService.getTransactionId());
    }
    else {
      this.formStatus = await this.originService.getFormStatus(this.hostService.getTransactionId(), endPoint);
    }

    if (
      this.formStatus?.status.toLowerCase() === 'completed' ||
      this.formStatus?.status.toLowerCase() === 'failed'
    ) {
      clearInterval(this.formsPollingIntervalId);
      clearTimeout(this.formsPollingTimeoutId);
      this.formsPollingIntervalId = null;
      this.formsPollingTimeoutId = null;
    }
  }

  async browseVerificationDocuments() {
    this._verificationAttachments = await this.openEFolderForm();
    this._verificationAttachments = this._verificationAttachments.map(
      (doc) => ({ ...doc, isSelected: true })
    );
  }
  async onVerificationFormSubmit() {
    if (this.commonForm.invalid) {
      this.commonForm.markAllAsTouched();
      return;
    }
    if (this.verificationsForm.invalid) {
      this.verificationsForm.markAllAsTouched();
      return;
    }
    if (!this.verificationsForm.value?.isInsuranceVerification && !this.verificationsForm.value?.isAsssociateVerification) {
      this.commonService.openSnackBar('Please select at least one verification option', '', 'warning');
      return;
    }
    this.isFormSubmitLoading = true;
    const selectedResources =
      this._verificationAttachments.filter((e) => e?.isSelected) || [];
    const submissionResourcesList = selectedResources.map(
      ({ isSelected, ...rest }) => rest
    );
    const transactionRequest = {
      request: {
        type: UnisourceRequestType.Order,
        options: {
          orderId: this.orderId,
          orderNumber: this.orderNumber,
          ...this.commonForm.getRawValue(),
          ...this.verificationsForm.value,
        },
        resources: submissionResourcesList,
      },
    };

    if (!this.transactionId || this.transactionId.trim() === '') {
      console.log(
        'Verification Create Transaction Request:',
        transactionRequest
      );
      try {
        this.setTimeoutForEPCNotResponding();
        const result = await this.hostService.createTransaction(
          transactionRequest
        );
        if (result) {
          this.transactionId = result?.id || '';
          this.hostService.setTransactionId(this.transactionId);
          this.clearEPCNotRespondingTimeout();
          this.getOrders(undefined, true);
        }
      } catch (error: any) {
        this.clearEPCNotRespondingTimeout();
        console.log(
          'Error occurred while creating verification transaction: ',
          {
            error,
          }
        );
        this.commonService.openSnackBar(
          'Error occurred while creating verification transaction',
          '',
          'error'
        );
        this.isFormSubmitLoading = false;
        return;
      }
    } else {
      console.log(
        'Verification Update Transaction Request:',
        transactionRequest
      );
      try {
        this.setTimeoutForEPCNotResponding();
        const result = await this.hostService.updateTransaction(
          transactionRequest,
          this.transactionId
        );
        if (result) {
          this.transactionId = result?.id || '';
          this.hostService.setTransactionId(this.transactionId);
          this.clearEPCNotRespondingTimeout();
        }
      } catch (error: any) {
        this.clearEPCNotRespondingTimeout();
        console.log(
          'Error occurred while updating verification transaction: ',
          {
            error,
          }
        );
        this.commonService.openSnackBar(
          'Error occurred while updating verification transaction',
          '',
          'error'
        );
        this.isFormSubmitLoading = false;
        return;
      }
    }
    this.startPollingFormStatus('verification');
    this.isFormSubmitLoading = false;
  }

  async onScheduleFormSubmit() {
    if (this.commonForm.invalid) {
      this.commonForm.markAllAsTouched();
      return;
    }
    if (this.schedulerForm.invalid) {
      this.schedulerForm.markAllAsTouched();
      return;
    }
    this.isFormSubmitLoading = true;
    const transactionRequest = {
      request: {
        type: UnisourceRequestType.Order,
        options: {
          orderId: this.orderId,
          orderNumber: this.orderNumber,
          ...this.commonForm.getRawValue(),
          ...this.schedulerForm.value,
        },
        resources: [],
      },
    };

    if (!this.transactionId || this.transactionId.trim() === '') {
      console.log('Schedule Create Transaction Request:', transactionRequest);
      try {
        this.setTimeoutForEPCNotResponding();
        const result = await this.hostService.createTransaction(
          transactionRequest
        );
        if (result) {
          this.transactionId = result?.id || '';
          this.hostService.setTransactionId(this.transactionId);
          this.clearEPCNotRespondingTimeout();
          this.getOrders(undefined, true);
        }
      } catch (error: any) {
        this.clearEPCNotRespondingTimeout();
        console.log('Error occurred while creating schedule transaction: ', {
          error,
        });
        this.commonService.openSnackBar(
          'Error occurred while creating schedule transaction',
          '',
          'error'
        );
        this.isFormSubmitLoading = false;
        return;
      }
    } else {
      console.log('Schedule Update Transaction Request:', transactionRequest);
      try {
        this.setTimeoutForEPCNotResponding();
        const result = await this.hostService.updateTransaction(
          transactionRequest,
          this.transactionId
        );
        if (result) {
          this.transactionId = result?.id || '';
          this.hostService.setTransactionId(this.transactionId);
          this.clearEPCNotRespondingTimeout();
        }
      } catch (error: any) {
        this.clearEPCNotRespondingTimeout();
        console.log('Error occurred while updating schedule transaction: ', {
          error,
        });
        this.commonService.openSnackBar(
          'Error occurred while updating schedule transaction',
          '',
          'error'
        );
        this.isFormSubmitLoading = false;
        return;
      }
    }
    this.startPollingFormStatus('scheduleNotary');
    this.isFormSubmitLoading = false;
  }

  async browseEmailDocuments() {
    this._emailAttachments = await this.openEFolderForm();
    this._emailAttachments = this._emailAttachments.map((doc) => ({
      ...doc,
      isSelected: true,
    }));
  }
  async onEmailFormSubmit() {
    if (this.commonForm.invalid) {
      this.commonForm.markAllAsTouched();
      return;
    }
    if (this.emailForm.invalid) {
      this.emailForm.markAllAsTouched();
      return;
    }
    this.isFormSubmitLoading = true;
    const selectedResources =
      this._emailAttachments.filter((e) => e?.isSelected) || [];
    const submissionResourcesList = selectedResources.map(
      ({ isSelected, ...rest }) => rest
    );
    const transactionRequest = {
      request: {
        type: UnisourceRequestType.Order,
        options: {
          orderId: this.orderId,
          orderNumber: this.orderNumber,
          ...this.commonForm.getRawValue(),
          ...this.emailForm.value,
        },
        resources: submissionResourcesList,
      },
    };

    if (!this.transactionId || this.transactionId.trim() === '') {
      console.log('Email Create Transaction Request:', transactionRequest);
      try {
        this.setTimeoutForEPCNotResponding();
        const result = await this.hostService.createTransaction(
          transactionRequest
        );
        if (result) {
          this.transactionId = result?.id || '';
          this.hostService.setTransactionId(this.transactionId);
          this.clearEPCNotRespondingTimeout();
          this.getOrders(undefined, true);
        }
      } catch (error: any) {
        this.clearEPCNotRespondingTimeout();
        console.log('Error occurred while creating email transaction: ', {
          error,
        });
        this.commonService.openSnackBar(
          'Error occurred while creating email transaction',
          '',
          'error'
        );
        this.isFormSubmitLoading = false;
        return;
      }
    } else {
      console.log('Email Update Transaction Request:', transactionRequest);
      try {
        this.setTimeoutForEPCNotResponding();
        const result = await this.hostService.updateTransaction(
          transactionRequest,
          this.transactionId
        );
        if (result) {
          this.transactionId = result?.id || '';
          this.hostService.setTransactionId(this.transactionId);
          this.clearEPCNotRespondingTimeout();
        }
      } catch (error: any) {
        this.clearEPCNotRespondingTimeout();
        console.log('Error occurred while updating email transaction: ', {
          error,
        });
        this.commonService.openSnackBar(
          'Error occurred while updating email transaction',
          '',
          'error'
        );
        this.isFormSubmitLoading = false;
        return;
      }
    }
    this.startPollingFormStatus('emailTeam');
    this.isFormSubmitLoading = false;
  }

  onOrderTransactionTypeChange(event: any): void {
    const selectedKey = event.value;
    const selectedText = event.source.triggerValue;
    this.productServiceList = this.productServiceAllList
      .filter((x) => x.transactionType === selectedText)
      .map((p) => ({
        id: p.productTypeID,
        name: p.productType,
      }));
    const _productServiceList = this.getHelocObjFromProductServiceList(this.productServiceList);
    this.titleOrderForm.patchValue({
      productServices: _productServiceList,
      transactionType: selectedKey
    });
    const questionConsideration = this.titleOrderForm.get('consideration');
    const questionAmount = this.titleOrderForm.get('amount');
    // Clear previous validators
    questionConsideration?.clearValidators();
    questionAmount?.clearValidators();

    this.titleOrderForm?.get('salesPrice')?.disable();
    this.titleOrderForm?.get('loanAmount')?.disable();
    if (selectedText.toLowerCase() === 'purchase') {
      this.titleOrderForm?.get('salesPrice')?.enable();
    }
    else if (selectedText.toLowerCase() === 'assumptions') {
      this.titleOrderForm?.get('loanAmount')?.enable();
    }
    // else if (selectedText.toLowerCase() === 'refinance'){
    //   questionConsideration?.setValidators([Validators.required, Validators.min(1)]);
    //   questionAmount?.setValidators([Validators.required, Validators.min(1)]);
    // }
    // Update validity
    questionConsideration?.updateValueAndValidity();
    questionAmount?.updateValueAndValidity();
  }
  onFeesTransactionTypeChange(event: any): void {
    const selectedKey = event.value;
    const selectedText = event.source.triggerValue;
    this.productServiceFeesList = this.productServiceAllList
      .filter((x) => x.transactionType === selectedText)
      .map((p) => ({
        id: p.productTypeID,
        name: p.productType,
      }));
    const _productServiceList = this.getHelocObjFromProductServiceList(this.productServiceFeesList);
    this.titleFeesForm.patchValue({
      productServices: _productServiceList,
      transactionType: selectedKey
    });

    const questionConsideration = this.titleFeesForm.get('consideration');
    const questionAmount = this.titleFeesForm.get('amount');
    // Clear previous validators
    questionConsideration?.clearValidators();
    questionAmount?.clearValidators();

    this.titleFeesForm?.get('salesPrice')?.disable();
    this.titleFeesForm?.get('loanAmount')?.disable();
    if (selectedText.toLowerCase() === 'purchase') {
      this.titleFeesForm?.get('salesPrice')?.enable();
    }
    else if (selectedText.toLowerCase() === 'assumptions') {
      this.titleFeesForm?.get('loanAmount')?.enable();
    }
    // else if (selectedText.toLowerCase() === 'refinance'){
    //   questionConsideration?.setValidators([Validators.required, Validators.min(1)]);
    //   questionAmount?.setValidators([Validators.required, Validators.min(1)]);
    // }
    // Update validity
    questionConsideration?.updateValueAndValidity();
    questionAmount?.updateValueAndValidity();
  }

  getHelocObjFromProductServiceList(productServiceList: any[]): any {
    const HelocIndex = productServiceList.findIndex(x => x.id === 29); // For Heloc 
    let _productService = productServiceList[0];
    if (HelocIndex !== -1 && this._credentials.username?.toLowerCase()?.includes('buttonfinance') && this.LoanDataForm.value?.loanType?.toLowerCase() === 'heloc') {
      _productService = productServiceList[HelocIndex];
    }
    return _productService;
  }

  onBorrowerAddressCheckboxChange(event: any) {
    const isChecked = event?.checked;
    const locationControl = this.schedulerForm.get('location');
    if (locationControl) {
      if (isChecked) {
        locationControl.setValue(
          this.schedulerForm.value?.borrowerAddress || ''
        );
        locationControl.disable({ emitEvent: false });
      } else {
        locationControl.setValue('');
        locationControl.enable({ emitEvent: false });
      }
    }
  }

  isEPCNotRespondingLoading: boolean = false;
  epcNotRespondingIntervalTimeoutId: any;
  setTimeoutForEPCNotResponding() {
    if (this.epcNotRespondingIntervalTimeoutId) clearTimeout(this.epcNotRespondingIntervalTimeoutId);
    this.epcNotRespondingIntervalTimeoutId = setTimeout(() => {
      this.transactionNotRespondingLog();
    }, 15 * 1000); // 15 seconds in milliseconds
  }
  clearEPCNotRespondingTimeout() {
    clearTimeout(this.epcNotRespondingIntervalTimeoutId);
    this.epcNotRespondingIntervalTimeoutId = null;
    this.hideTransactionResponseAPIStatusDetailModal();
  }
  async transactionNotRespondingLog() {
    const logData = {
      message: "The EPC system is taking longer than expected to respond.",
      level: LogType.Error,
      loanNumber: this.loanNumber,
      instanceId: this.instanceId,
      source: "Transaction"//"Title Fee (Update Transaction)"
    }
    this.showTransactionResponseAPIStatusDetailModal();
    const response = await this.originService.integrationsLog(logData);
  }
  transactionNotRespondingWaitBtn() {
    this.clearEPCNotRespondingTimeout();
    this.setTimeoutForEPCNotResponding();
  }

  missingFields: string[] = [];
  checkRequiredFields(isCheckPropertyAddress: boolean = true): boolean {
    this.missingFields = [];

    if (!this._loanData?.loanNumber?.toString().trim()) {
      this.missingFields.push('Loan Number (Field ID - 364)');
    }
    if (!this._loanData?.baseLoanAmount) {
      this.missingFields.push('Loan Amount (Field ID - 2)');
    }
    if (!this.borrower?.firstName?.toString().trim()) {
      this.missingFields.push('Borrower First Name (Field ID - 4000)');
    }
    if (!this.borrower?.lastName?.toString().trim()) {
      this.missingFields.push('Borrower Last Name (Field ID - 4002)');
    }
    if (isCheckPropertyAddress) {
      if (!this._loanData?.property?.streetAddress?.toString().trim()) {
        this.missingFields.push('Address (Field ID - 11)');
      }
      if (!this._loanData?.property?.city?.toString().trim()) {
        this.missingFields.push('City (Field ID - 12)');
      }
      if (!this._loanData?.property?.county?.toString().trim()) {
        this.missingFields.push('County (Field ID - 13)');
      }
      if (!this._loanData?.property?.postalCode?.toString().trim()) {
        this.missingFields.push('Zip (Field ID - 15)');
      }
      if (!this._loanData?.property?.state?.toString().trim()) {
        this.missingFields.push('State (Field ID - 14)');
      }
    }

    // Show modal if any fields are missing
    if (this.missingFields.length > 0) {
      this.showRequiredFieldsModal();
      return true;
    }
    else {
      return false;
    }
  }

  feesDetailModalInstance: any;
  showFeesDetailModal() {
    this.feesDetailModalInstance.show();
  }
  hideFeesDetailModal() {
    this.feesDetailModalInstance.hide();
  }

  showOrderFeesStatusHistoryModal() {
    $('#orderFeesStatusHistoryModal').modal('show');
  }
  hideOrderFeesStatusHistoryModal() {
    $('#orderFeesStatusHistoryModal').modal('hide');
  }

  modalInstance: any;
  showLoadingProcessDetailModal() {
    this.modalInstance.show();
  }
  hideLoadingProcessDetailModal() {
    this.modalInstance.hide();
  }

  documentProcessModalInstance: any;
  showLoadingDocumentProcessDetailModal() {
    this.documentProcessModalInstance.show();
  }
  hideLoadingDocumentProcessDetailModal() {
    this.documentProcessModalInstance.hide();
  }

  formSubmissionProcessModalInstance: any;
  showLoadingFormSubmitionProcessDetailModal() {
    this.formSubmissionProcessModalInstance.show();
  }
  hideLoadingFormSubmitionProcessDetailModal() {
    this.formSubmissionProcessModalInstance.hide();
  }

  transactionResponseAPIStatusModalInstance: any;
  showTransactionResponseAPIStatusDetailModal() {
    this.transactionResponseAPIStatusModalInstance.show();
  }
  hideTransactionResponseAPIStatusDetailModal() {
    this.transactionResponseAPIStatusModalInstance.hide();
  }

  requiredFieldsModalInstance: any;
  showRequiredFieldsModal() {
    this.requiredFieldsModalInstance.show();
  }
  hideRequiredFieldsModal() {
    this.requiredFieldsModalInstance.hide();
  }


  activeTab: string = 'titleFees'; // default to 'titleFees' tab
  onTabChange(tab: string): void {
    this.activeTab = tab;

    if (this.activeTab === 'titleFees') {
      this.LoanDataForm.get('propertyAddress')?.enable();
    } else {
      this.LoanDataForm.get('propertyAddress')?.disable();
    }

    if (this.activeTab === 'order') {
      this.commonForm.get('titleOrder')?.disable();
      this.setTopRecentOrder();
    } else {
      this.commonForm.get('titleOrder')?.enable();
    }

    if (this.activeTab === 'downloadDocuments') {
      //if (this._documents.length === 0)
      this.getDocuments(this.orderId, this.orderNumber);
    }

    if (this.activeTab === 'uploadDocuments') {
      this.getEPCDocuments(this.orderId, this.orderNumber);
    }
  }

  disableCloseButton() {
    const closeBtn = document.getElementById('closeAppBtn');
    if (closeBtn) {
      this.renderer.setAttribute(closeBtn, 'disabled', 'true');
    }
  }

  enableCloseButton() {
    const closeBtn = document.getElementById('closeAppBtn');
    if (closeBtn) {
      this.renderer.removeAttribute(closeBtn, 'disabled');
    }
  }

  opensessionDialog() {
    this.commonService.openSessionExpiredModal();
  }

  isSessionResetLoading: boolean = false;
  async resetApp() {
    //location.reload(); // or use router.navigate(['/login']) 
    this.isSessionResetLoading = true;

    var origin = await this.hostService.getTransactionOrigin();
    console.log(origin);
    this.transactionId = origin.transactionId || '';
    this._originData = await this.originService.getLoanData(origin.id, origin.partnerAccessToken);
    this.authService.setJWTToken(this._originData?.jwtToken || '');

    this.isSessionResetLoading = false;
    this.commonService.closeSessionExpiredModal();
  }

}
